// src/pages/SelectTechnician.js
import React, { useState, useEffect } from "react";
import { ref, onValue, update } from "firebase/database";
import { useParams, useNavigate, Link } from "react-router-dom";
import { db } from "../utilities/firebaseConfig";
import backicon from "../assets/backicon.svg";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { IoCloseOutline } from "react-icons/io5";
import workimageicon from "../assets/imgicon.svg";
import cleanimg1 from "../assets/clean1.png";
import cleanimg2 from "../assets/clean2.png";
import cleanimg3 from "../assets/clean3.png";
import ratingimage from "../assets/workerimg.png";
import eclipseicon from "../assets/ellipse.svg";
import checked from "../assets/checked.svg";
import filetericon from "../assets/filtericon.svg";
import unchecked from "../assets/unchecked.svg";
import forwardicon from "../assets/forwardicon.svg";
import taskicon from "../assets/taskimgicon.svg";
import moneyicon from "../assets/moneyicon.svg";
import profileimg from "../assets/workerimg.png";
import closemodal from "../assets/closemodal.svg";
import timeicon from "../assets/ttime.svg";
import calendericon from "../assets/tcalendar.svg";
import locationicon from "../assets/tlocation.svg";

const SelectTechnician = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [showcat, setShowcat] = useState(false);
  const [job, setJob] = useState(null);
  const [atask, setAtask] = useState("");
  const [technicians, setTechnicians] = useState([]);
  const [filteredTechnicians, setFilteredTechnicians] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedWorker, setSelectedWorker] = useState();
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [minExperience, setMinExperience] = useState("");
  const [minRating, setMinRating] = useState("");
  const [activeprofile, setActiveprofile] = useState(null);
  const [tasksum, setTasksum] = useState(false);
  // Fetch job details.
  useEffect(() => {
    const jobRef = ref(db, `jobs/${jobId}`);
    onValue(jobRef, (snapshot) => {
      if (snapshot.exists()) {
        setJob(snapshot.val());
      }
    });
  }, [jobId]);

  useEffect(() => {
    const techRef = ref(db, "technicians");

    onValue(techRef, (snapshot) => {
      if (snapshot.exists()) {
        const techArray = Object.entries(snapshot.val()).map(([id, tech]) => ({
          id,
          ...tech,
        }));

        const approved = techArray.filter(
          (tech) => tech.approval === "accepted"
        );

        // Log the available approved technicians
        console.log("Approved Technicians: ", approved);

        // Filter technicians based on the matching serviceType
        const withServicePrice = approved
          .map((tech) => {
            const match = tech.services?.find(
              (s) => s.name?.toLowerCase() === job?.serviceType?.toLowerCase()
            );

            if (match) {
              // If there's a match, add service price to the technician data
              return {
                ...tech,
                servicePrice: Number(match.price),
              };
            } else {
              // If no match, return null
              return null;
            }
          })
          .filter((tech) => tech !== null); // Filter out null values where there's no match

        // If no technicians matched, set filteredTechnicians as an empty array
        if (withServicePrice.length === 0) {
          setFilteredTechnicians([]);
        } else {
          setTechnicians(withServicePrice);
          setFilteredTechnicians(withServicePrice);
        }
      }
    });
  }, [job]);

  useEffect(() => {
    let filtered = technicians.filter((tech) => {
      if (minPrice && tech.servicePrice < Number(minPrice)) return false;
      if (maxPrice && tech.servicePrice > Number(maxPrice)) return false;

      if (
        selectedLevel &&
        tech.level?.toLowerCase() !== selectedLevel.toLowerCase()
      )
        return false;

      if (minExperience && Number(tech.expyears || 0) < Number(minExperience))
        return false;

      if (minRating && Number(tech.rating || 0) < Number(minRating))
        return false;

      return true;
    });

    setFilteredTechnicians(filtered);
  }, [
    technicians,
    minPrice,
    maxPrice,
    selectedLevel,
    minExperience,
    minRating,
  ]);

  const selectTechnician = async (techId) => {
    if (!jobId) {
      console.error("Error: jobId is undefined.");
      return;
    }
    console.log("Updating job:", jobId, "with technician:", techId);

    try {
      await update(ref(db, `jobs/${jobId}`), {
        technicianId: techId,
        status: "awaiting technician's approval",
        hourlyRate: activeprofile.servicePrice,
        trustSupportFee: 8000,
        totalFee: activeprofile.servicePrice + 8000,
      });
      alert("Technician selected successfully!");
      navigate(`/client/job/${jobId}`);
    } catch (error) {
      console.error("Error selecting technician:", error.message);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    // Arrays for the short names of days and months.
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get the components of the date.
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${dayName}, ${monthName} ${day}, ${year}`;
  }

  const openModal = (worker) => {
    setSelectedWorker(worker); // Set the selected worker details
  };

  const closeModal = () => {
    console.log("Modal closing...");
    setSelectedWorker(null); // Close the modal
  };

  const formatPrice = (price) => {
    if (!price) return "";
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <>
      <div className={`navbar visible`}>
        <div className='navbar-container'>
          <div className='navbar-logo-left'>
            <Link to='' className='navbar-logo'>
              ProfixExpress
            </Link>
          </div>
        </div>
      </div>
      <div className='bookingpagecnt bokspas'>
        <button
          className='backicon'
          onClick={() => navigate("/technician/dashboard")}
        >
          <img src={backicon} className='backiconimg' alt='' srcset='' />
        </button>
        <div className='thegap'></div>
        <div className='booktp'>
          <h1 className='booktptitle'>Filter</h1>
          <button className='booktpfilt' onClick={() => setShowcat(true)}>
            <img src={filetericon} alt='' />
          </button>
        </div>

        <div className='thegap'></div>

        <div className='seletcnta'>
          <h3 className='seletcntatitle'>Technicians available</h3>
          <div className='thegap'></div>
          <div className='selettechcrdcnt'>
            {filteredTechnicians.length > 0 ? (
              filteredTechnicians.map((tech) => (
                <div
                  key={tech?.id}
                  className='selettechcard'
                  onClick={() => setActiveprofile(tech)}
                >
                  <div className='selettechcardtop'>
                    <div className='selctopleft'>
                      <img
                        className='selctprofurl'
                        src={tech?.profileUrl}
                        alt=''
                      />
                      <div
                        className={
                          tech?.rating > 3.5 ? "wlitoprgreen" : "wlitopryellow"
                        }
                      >
                        <svg
                          width='12'
                          height='12'
                          viewBox='0 0 15 15'
                          fill='#fff'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                            fill='#fff'
                          ></path>
                        </svg>
                        <p className='ratingnum'>{tech?.rating}</p>
                      </div>
                    </div>
                    <div className='selctopright'>
                      <h4 className='selctoprightitle'>{tech?.fullName}</h4>{" "}
                      <div className='selctoprightbtm'>
                        <p className='jdtechgreat'>{tech?.level}</p>
                        <p className='jdtechminum'>2 HOUR MAXIMUM</p>
                      </div>
                    </div>
                  </div>

                  <div className='expviewprofile'>
                    <p className='expyears'>{tech?.expyears} Years exp</p>
                    {/* <button
                      className='expviewbtn'
                      onClick={() => setActiveprofile(tech)}
                    >
                      View profile <img src={forwardicon} alt='' />
                    </button> */}
                  </div>

                  <div className='selettetechbkpr'>
                    <p className='selpric'>
                      ₦{formatPrice(tech?.servicePrice)}/hr
                    </p>
                    {/* <button
                      className='selbkpr'
                      onClick={() => selectTechnician(tech.id)}
                    >
                      Book and continue
                    </button> */}
                  </div>
                </div>
              ))
            ) : (
              <p>No technicians available for the selected service.</p>
            )}
          </div>
        </div>
      </div>
      {showcat && (
        <>
          <div className='downmodal' onClick={() => setShowcat(false)}></div>
          <div className='downmodalbody'>
            <div className='downmodalway'>
              <div className='thegap'></div>
              <div className='bttsleft'>
                <div className='thetechtops'>
                  <h2 className='bttslefttitle'>Filter professionals</h2>
                  <button onClick={() => setShowcat(false)}>
                    <IoCloseOutline />
                  </button>
                </div>

                <div className='thebiggap'></div>
                <div className='bttsleftitems'>
                  <div className='ylinputform'>
                    <p className='bttsdftitle'>Technician level</p>
                    <div className='techlevelsep'>
                      <div
                        className={
                          selectedLevel === "elite"
                            ? "tskitemactive"
                            : "tskitemnotactive"
                        }
                        onClick={() => setSelectedLevel("elite")}
                      >
                        <img
                          src={selectedLevel === "elite" ? checked : unchecked}
                          alt=''
                        />
                        <div className='tskitemleft'>
                          <label className='tskla'>Elite</label>
                        </div>
                      </div>

                      <div
                        className={
                          selectedLevel === "great value"
                            ? "tskitemactive"
                            : "tskitemnotactive"
                        }
                        onClick={() => setSelectedLevel("great value")}
                      >
                        <img
                          src={
                            selectedLevel === "great value"
                              ? checked
                              : unchecked
                          }
                          alt=''
                        />
                        <div className='tskitemleft'>
                          <label className='tskla'>Great Value</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='thegap'></div>
                  <div className='inputcnt'>
                    <label htmlFor=''>Years of experience</label>
                    <input
                      type='number'
                      placeholder='Min Experience'
                      value={minExperience}
                      onChange={(e) => setMinExperience(e.target.value)}
                    />
                  </div>
                  <div className='thegap'></div>
                  <div className='theflexs'>
                    <div className='inputcnt'>
                      <label htmlFor=''>Min price</label>
                      <input
                        type='number'
                        placeholder='Min Price'
                        value={minPrice}
                        onChange={(e) => setMinPrice(e.target.value)}
                      />
                    </div>
                    <div className='inputcnt'>
                      <label htmlFor=''>Max price</label>
                      <input
                        type='number'
                        placeholder='Max Price'
                        value={maxPrice}
                        onChange={(e) => setMaxPrice(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className='thebiggap'></div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {activeprofile && (
        <>
          <div
            className='profilemodal'
            onClick={() => setActiveprofile(null)}
          ></div>
          <div className='profilebody'>
            <div className='profiletop'>
              <button
                className='closemodalcnt'
                onClick={() => setActiveprofile(false)}
              >
                <img
                  src={closemodal}
                  alt=''
                  srcset=''
                  className='closemodalimg'
                />
              </button>
            </div>
            <div className='jdtechasleft'>
              <img
                src={activeprofile.profileUrl}
                alt=''
                className='jdtechimg'
              />
              <div className='thesepare'>
                <div className='jdtechpro'>
                  <h1 className='jdtechproname'>{activeprofile.fullName}</h1>
                  <div
                    className={
                      activeprofile.rating > 3.5
                        ? "wlitoprgreen"
                        : "wlitopryellow"
                    }
                  >
                    <svg
                      width='12'
                      height='12'
                      viewBox='0 0 15 15'
                      fill='#fff'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                        fill='#fff'
                      ></path>
                    </svg>
                    <p className='ratingnum'>{activeprofile.rating}</p>
                  </div>
                </div>
                <p className='jdtechgreat'>{activeprofile.level}</p>
                <p className='jdtechminum'>2 HOUR MINIMUM</p>
              </div>
            </div>
            <div className='thegap'></div>
            <div className='divider'></div>
            <div className='thegap'></div>
            <p className='profiletopic'>Bio</p>
            <div className='thegap'></div>
            <p className='profilesentence'>{activeprofile.bio}</p>
            <div className='thegap'></div>
          </div>
          <div className='thebottomfetch'>
            <div className='selettetechbkpr'>
              <p className='selpric'>
                ₦{formatPrice(activeprofile.servicePrice)}/hr
              </p>
              <button className='selbkpr' onClick={() => setTasksum(true)}>
                Book and continue
              </button>
            </div>
          </div>
        </>
      )}
      {tasksum && (
        <>
          <div className='summodal'></div>
          <div className='sumbody'>
            <div className='sumtop'>
              <button
                className='closemodalcnt'
                onClick={() => setTasksum(false)}
              >
                Back
              </button>
            </div>
            <div className='thegap'></div>
            <h1 className='sumttitle'>Task Summary</h1>
            <div className='thebiggap'></div>
            <p className='profidestitle'>Technician Details</p>
            <div className='thegap'></div>
            <div className='profilenaimg'>
              <img src={activeprofile.profileUrl} alt='' />
              <h1 className='sumpara'>{activeprofile.fullName}</h1>
            </div>
            <div className='thegap'></div>

            <div className='thegap'></div>
            <p className='profidestitle'>Task title</p>
            <div className='thegap'></div>
            <p className='proffdes'>{job.title}</p>
            <div className='thebiggap'></div>
            <p className='profidestitle'>Your task details</p>

            <div className='thegap'></div>
            <p className='proff'>{job.description}</p>
            <div className='thegap'></div>
            <div className='profitems'>
              <img src={timeicon} alt='' className='pritemimg' />
              {job.timeOfDay === "morning" && (
                <p>
                  {job.timeOfDay} <span>Before 10am</span>
                </p>
              )}
              {job.timeOfDay === "midday" && (
                <p>
                  {job.timeOfDay} <span>10am - 2pm</span>
                </p>
              )}
              {job.timeOfDay === "afternoon" && (
                <p>
                  {job.timeOfDay} <span>2pm - 6pm</span>
                </p>
              )}
              {job.timeOfDay === "evening" && (
                <p>
                  {job.timeOfDay} <span>After 6pm</span>
                </p>
              )}
            </div>
            <div className='profitems'>
              <img src={calendericon} alt='' className='pritemimg' />
              <p>{formatDate(job.scheduledDate)}</p>
            </div>
            <div className='profitems'>
              <img src={locationicon} alt='' className='pritemimg' />
              <p>{job.address}</p>
            </div>
            <div className='thegap'></div>
            <div className='divider'></div>
            <div className='thegap'></div>
            <p className='profidestitle'>Price Details</p>
            <div className='thegap'></div>
            <div className='theprdet'>
              <div className='prodestri'>
                <p className='prodeslef'>Hourly rate</p>
                <p className='prodesright'>
                  ₦{formatPrice(activeprofile.servicePrice)}/hr
                </p>
              </div>
              <div className='prodestri'>
                <p className='prodeslef'>Trust/support fee</p>
                <p className='prodesright'> ₦8,000</p>
              </div>
              <div className='prodestri'>
                <p className='prodeslef'>Total fee</p>
                <p className='prodesright'>
                  ₦{formatPrice(activeprofile.servicePrice + 8000)}
                </p>
              </div>
            </div>
          </div>

          <div className='thebottomfetchh'>
            <div className='selettetechbkprr'>
              <button
                className='selbkprr'
                onClick={() => selectTechnician(activeprofile.id)}
              >
                Confirm payment and chat
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SelectTechnician;
